import {mapState,mapGetters} from 'vuex'

export var settingsMixin = {

  watch: {
  },
  computed: {
    ...mapGetters('settings',['userId','isAdmin','aliasUser','isLoggedIn','isConnectedWithStripe']),
    ...mapState('settings',['app_session','app_locale','app_user','app_loading','app_auth_error','app_stripe_id']),
    userOrAliasId(){
      return (this.aliasUser)?this.aliasUser.id:this.userId;
    }
  },
  methods: {
  
    setAppLoading(isLoading){
      this.$store.commit('settings/SET_APP_LOADING', isLoading)
    },
    initSession(){
      return this.$store.dispatch('settings/initSession');
    },
    logoutAndInitSession(){
      return new Promise((resolve, reject) => {
        this.logout().then(()=>{
          this.initSession().then((response)=>{
            resolve(response);
          }).catch((ex) => {
            this.logout();
            reject(ex);
          });
        }).catch((ex) => {
          reject(ex);
        });
      });
    },
    login(credentials){
     
      //Logout - reinit Session - Register - Login
      return new Promise((resolve, reject) => {
        this.logoutAndInitSession().then(()=>{
          this.$store.dispatch('settings/login',credentials).then((responseLogin)=>{
          if(responseLogin){
            //Call method to get notification in menu
            if(this.aliasUser.id){
              this.$store.dispatch('bookings/getBookingsByHost',this.aliasUser.id);
            }

            //resolve it
            resolve(responseLogin);
          }else{
            reject(null);
          }
          }).catch((ex) => {
            reject(ex);
          });
        }).catch((ex) => {
          reject(ex);
        });
      });
    },
    logout(){
      return new Promise((resolve) => {
       this.$store.dispatch('settings/logout').then(()=>{

       }).finally(()=>{
         /* Remove stored data */
        this.$store.dispatch('bookings/destroy');
        this.$store.dispatch('locations/destroy');
        //TODO Enhancement: Remove all stored data
        resolve();
       });
      });
    },
    changePassword(d){
      return this.$store.dispatch('settings/changePassword',d);
    },
    requestPasswordChange(email){
      return this.$store.dispatch('settings/requestPasswordChange',email);
    },
    getStripeLoginLink(userId){
      return this.$store.dispatch('settings/getStripeLoginLink',userId);
    },
    register(data){
      //Logout - reinit Session - Register - Login
      return new Promise((resolve, reject) => {
        this.logoutAndInitSession().then(()=>{
          this.$store.dispatch('settings/register',data).then((responseRegister)=>{
            if(responseRegister){
              let credentials={
                email:data.email,
                password:data.password
              };
              this.login(credentials).then((responseLogin)=>{
                resolve(responseLogin);
              }).catch((ex)=>{
                reject(ex);
              });
            }else{
              reject(null);
            }
          }).catch((ex) => {
            reject(ex);
          });
        }).catch((ex) => {
          reject(ex);
        });
      });
    },
    updateUserObject(user,data){
      this.$store.commit('settings/UPDATE_APP_USER', {user,data})
    },
    updateUser(data){
      return this.$store.dispatch('settings/updateUser',data);
    },
    getUserById(id){
      return this.$store.dispatch('settings/getUserById',id);
    },
    setAliasByUserId(id){
      return this.$store.dispatch('settings/setAliasByUserId',id);
    }
  },
  created: function () {
  }
}
